import TrustpilotPlugin from 'vue-trustpilot'

const carouselWidget = {
  templateId: '56278e9abfbbba0bdcd568bc',
  businessunitId: process.env.TRUSTPILOT_BUSINESS_UNIT_ID,
  reviewUrl: process.env.TRUSTPILOT_REVIEW_URL,
  locale: 'en-GB',
  styleHeight: '40px'
}

const reviewsListWidget = {
  templateId: '5419b6a8b0d04a076446a9ad',
  businessunitId: process.env.TRUSTPILOT_BUSINESS_UNIT_ID,
  reviewUrl: process.env.TRUSTPILOT_REVIEW_URL,
  locale: 'en-NZ',
  styleHeight: '24px'
}

const options = {
  widgets: {
    carousel: carouselWidget,
    list: reviewsListWidget
  }
}

export default ({ Vue }) => {
  Vue.use(TrustpilotPlugin, options)
}
